import styled from 'styled-components'
import { Theme } from '../../../../Theme';


const  Content = styled.div`
    width: 100%;
    height: 40px;
    background-color: ${Theme.FIRST_COLOR};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    cursor: pointer;

    button{
        span{
            color: ${Theme.THIRD_COLOR};
        }
    }
        
`;

export const Styled = {
    Content
}